import { constant, get, noop } from 'lodash/fp';

import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
  PLAYER_SWAP_SET_GROUP,
  PLAYER_SWAP_SET_SELECTED,
  PLAYER_SWAP_SET_SWAP
} from '../constants/actionTypes';
import {
  PLAYER_SWAP_SELECT_SLATE,
  PLAYER_SWAP_SLATES,
  PLAYER_SWAP_SUBMISSION
} from '../constants/apiTypes';
import decodePlayerPool from '../normalizers/decodePlayerPool';
import decodeSlate from '../normalizers/decodeSlate';
import createReducer from '../utils/createReducer';
import switchFunc from '../utils/switchFunc';
import { mapErrorMessages } from '../utils/challengeUtils';

const initialState = {
  hardErrorMessages: [],
  loadingSlates: false,
  loadingSlate: false,
  playerPool: {},
  selectedGroupId: undefined,
  selectedSlate: {},
  selectedPlayerId: undefined,
  selectedPosition: undefined,
  selectedPositionAbbr: undefined,
  softErrorMessages: [],
  submissionData: [],
  submitting: false,
  swapPlayerId: undefined
};

const apiRequestReducer = switchFunc(
  {
    [PLAYER_SWAP_SLATES]: constant({
      loadingSlates: true,
      playerPool: {},
      selectedPlayerId: undefined,
      selectedSlate: {},
      slates: [],
      submissionData: [],
      swapPlayerId: undefined,
      submitting: false,
      hardErrorMessages: [],
      sortErrorMessages: []
    }),
    [PLAYER_SWAP_SELECT_SLATE]: constant({
      loadingSlate: true,
      playerPool: {},
      selectedPlayerId: undefined,
      selectedSlate: {},
      submissionData: [],
      swapPlayerId: undefined,
      submitting: false,
      hardErrorMessages: [],
      sortErrorMessages: []
    }),
    [PLAYER_SWAP_SUBMISSION]: constant({
      hardErrorMessages: [],
      sortErrorMessages: [],
      submissionData: [],
      submitting: true
    })
  },
  constant(noop)
);

const apiSuccessReducer = switchFunc(
  {
    [PLAYER_SWAP_SLATES]: (state, action) => ({
      loadingSlates: false,
      slates: (action.data || []).map(
        ({ id, name, sport_id: sportId, competition_type_id: competitionId }) => ({
          id,
          name,
          sportId,
          competitionId // this shoud be competitionTypeId, using competitionId for historical error with sportCategory filtering
        })
      )
    }),
    [PLAYER_SWAP_SELECT_SLATE]: (state, action) => ({
      loadingSlate: false,
      playerPool: decodePlayerPool(action.data),
      selectedSlate: decodeSlate(action.data)
    }),
    [PLAYER_SWAP_SUBMISSION]: (state, action) => ({
      softErrorMessages: mapErrorMessages(get('soft_errors', action.meta)),
      submissionData: get('updated_lineups', action.data) || [],
      submitting: false
    })
  },
  constant(noop)
);

const apiFailureReducer = switchFunc(
  {
    [PLAYER_SWAP_SUBMISSION]: (state, action) => ({
      hardErrorMessages: mapErrorMessages(action.errors),
      submitting: false
    })
  },
  constant(noop)
);

const playerSwapReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiRequestReducer(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccessReducer(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailureReducer(action.api)(state, action),
  [PLAYER_SWAP_SET_GROUP]: (state, action) => ({
    selectedGroupId: action.groupId,
    selectedPlayerId: undefined,
    selectedPosition: undefined,
    selectedPositionAbbr: undefined,
    swapPlayerId: undefined
  }),
  [PLAYER_SWAP_SET_SELECTED]: (state, action) => ({
    selectedPlayerId: action.playerId,
    selectedPosition: action.positionId,
    selectedPositionAbbr: action.positionAbbr,
    swapPlayerId: undefined
  }),
  [PLAYER_SWAP_SET_SWAP]: (state, action) => ({
    hardErrorMessages: [],
    softErrorMessages: [],
    swapPlayerId: action.playerId
  })
});

export default playerSwapReducer;
